import * as Yup from 'yup';

const lastName = Yup.string()
  .trim()
  .min(1, 'Last name is required')
  .required('Last name is required');

export default lastName;
